/**
 * D&D 5e HP damage / healing model — the SINGLE source of truth shared by the
 * server (authoritative `sheet:apply-damage` / `apply-healing` handlers) and the
 * client (optimistic ± HP prediction in the HUD). Keeping one implementation
 * means the optimistic overlay always matches what the server will do, so the
 * reconcile never sticks on a wrong prediction.
 *
 * Future damage resistances / vulnerabilities / immunities hook in HERE (scale
 * `amount` before absorption) so client and server stay identical automatically.
 */
/**
 * Apply `amount` of damage, absorbing into temporary HP first (PHB p.198), then
 * into current HP (floored at 0). Pure — returns the new {hp, temp}.
 */
export function applyDamageToHp(hp, temp, amount) {
    if (amount <= 0)
        return { hp, temp };
    const t = Math.max(0, temp);
    const absorbed = Math.min(t, amount);
    const remaining = amount - absorbed;
    return { hp: Math.max(0, hp - remaining), temp: t - absorbed };
}
/**
 * Apply `amount` of healing to current HP, clamped to `max`. Temporary HP is
 * unaffected by healing (PHB p.198). Pure — returns the new hp.
 */
export function applyHealingToHp(hp, max, amount) {
    if (amount <= 0)
        return hp;
    return Math.min(max, hp + amount);
}
